<app-dashboard-stats-card [title]="'Offered'" subtitle="Packages that have been 'Offered'."
                          [count]="getPackageCount()" [routerLink]="'/my-packages'" [queryParams]="{ open: true, open_o: 'is', offered: true, offered_o: 'is' }" />
